module.exports = __webpack_public_path__ + "img/shadow.eedbc7ad.jpg";